// Геометрия листа A4 по СТО (как у сборщика writer: lib/sto_lib.set_page_setup, setup_page_numbers) в CSS-пикселях
// без масштаба (96 dpi): поля 25/15/20/20 мм, колонтитул (номер страницы) - 12,5 мм от нижнего края, TNR 14.
export const MM = 96 / 25.4;
export const PT = 96 / 72;
export const PAGE_W = 210 * MM;
export const PAGE_H = 297 * MM;
export const M_TOP = 20 * MM;
export const M_BOTTOM = 20 * MM;
export const M_LEFT = 25 * MM;
export const M_RIGHT = 15 * MM;
export const TEXT_H = PAGE_H - M_TOP - M_BOTTOM;       // 257 мм
export const TEXT_W = PAGE_W - M_LEFT - M_RIGHT;       // 170 мм
/** промежуток между листами на экране (без масштаба) */
export const GAP = 18;
export const STRIDE = PAGE_H + GAP;
/** нижний край строки колонтитула: 12,5 мм от края листа (w:footer=709) */
export const FOOTER_BOTTOM = PAGE_H - 12.5 * MM;
/** высота одной строки TNR 14 с одинарным интервалом (Word: (1825+443+87)/2048 × 14 пт) */
export const LINE_14_SINGLE = 16.1 * PT;

/** Верх текста на страницах основной части: в DOCX writer пустой абзац верхнего колонтитула (стиль «Обычный»,
 *  интервал 1,5 = 24,15 пт) начинается в 12,5 мм от края (w:header=709) и заканчивается ниже верхнего поля 20 мм -
 *  Word опускает текст до его низа: 709 twips + 24,15 пт = 59,6 пт (21,03 мм). По PDF из Word: первая строка
 *  страницы - базовая линия 72,7 пт = 59,6 + 13,06 (подъём TNR 14). */
export const BODY_TOP = 35.45 * PT + 24.15 * PT;
export const BODY_H = PAGE_H - M_BOTTOM - BODY_TOP;
export const pageTop = (i: number) => i * STRIDE;
export const contentTop = (i: number) => i * STRIDE + BODY_TOP;
export const contentBottom = (i: number) => i * STRIDE + BODY_TOP + BODY_H;
export const totalHeight = (n: number) => Math.max(1, n) * STRIDE - GAP;
